import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

export const DashboardConvertCardLoader = styled(ContentLoader)`
  display: flex;
  height: 14.2rem;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.text.interactive};
`;

export const Fee = styled.rect`
  width: 5.5rem;
  height: 5rem;

  x: 0;
  y: 0.5rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};
`;

export const PercentageLineFirst = styled.rect`
  width: 11rem;
  height: 0.7rem;

  x: 0;
  y: 9rem;

  rx: ${({ theme }) => theme.borderRadius.low};
  ry: ${({ theme }) => theme.borderRadius.low};
`;

export const PercentageFirst = styled.rect`
  width: 2rem;
  height: 2rem;

  x: 0;
  y: 10.5rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};
`;

export const AmountFirst = styled.rect`
  width: 7rem;
  height: 1rem;

  x: 0;
  y: 13rem;

  rx: ${({ theme }) => theme.borderRadius.low};
  ry: ${({ theme }) => theme.borderRadius.low};
`;

export const PercentageLineSecond = styled.rect`
  width: 12rem;
  height: 0.7rem;

  x: 11.5rem;
  y: 9rem;

  rx: ${({ theme }) => theme.borderRadius.low};
  ry: ${({ theme }) => theme.borderRadius.low};
`;

export const PercentageSecond = styled.rect`
  width: 2rem;
  height: 2rem;

  x: 16.5rem;
  y: 10.5rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};
`;

export const AmountSecond = styled.rect`
  width: 9rem;
  height: 1rem;

  x: 13rem;
  y: 13rem;

  rx: ${({ theme }) => theme.borderRadius.low};
  ry: ${({ theme }) => theme.borderRadius.low};
`;

export const PercentageLineThird = styled.rect`
  width: 11rem;
  height: 0.7rem;

  x: 24rem;
  y: 9rem;

  rx: ${({ theme }) => theme.borderRadius.low};
  ry: ${({ theme }) => theme.borderRadius.low};
`;

export const PercentageThird = styled.rect`
  width: 2rem;
  height: 2rem;

  x: 33rem;
  y: 10.5rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};
`;

export const AmountThird = styled.rect`
  width: 9rem;
  height: 1rem;

  x: 26.2rem;
  y: 13rem;

  rx: ${({ theme }) => theme.borderRadius.low};
  ry: ${({ theme }) => theme.borderRadius.low};
`;
